import PropTypes from 'prop-types'
import React from 'react'

import './PlatformLogo.less'

const classNames = require('classnames')

const cssClassSeparator = '-'
const colorClassName = 'color'
const grayColorClassName = 'white'
const largeClassName = 'lg'
const smallClassName = 'sm'

class PlatformLogoComponent extends React.Component {
  getLogoClass () {
    let platformClasses = []

    platformClasses.push(this.getColorClass())
    platformClasses.push(this.getSizeClass())
    platformClasses.push(this.props.platformId)

    return platformClasses.join(cssClassSeparator)
  }

  getColorClass () {
    if (this.props.color) {
      return colorClassName
    } else {
      return grayColorClassName
    }
  }

  getSizeClass () {
    if (this.props.large) {
      return largeClassName
    } else {
      return smallClassName
    }
  }

  render () {
    let classesObject = {
      'platform-logo': true,
      [this.getLogoClass()]: true
    }

    return (
      <div className={classNames(classesObject)} />
    )
  }
}

PlatformLogoComponent.propTypes = {
  platformId: PropTypes.number.isRequired,
  color: PropTypes.bool,
  large: PropTypes.bool
}

PlatformLogoComponent.defaultProps = {
  color: true,
  large: true
}

export default PlatformLogoComponent



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/PlatformLogo/index.js